/* eslint-disable arrow-body-style */

import React from "react";

// Custom
import modelIzlet from "@/models/izlet";
import modelIzletVodicSudionik from "@/models/izlet_vodic_sudionik";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import HPSIzletForm from "./Forms/HPSIzletForm";
import { Permissions } from "@/lib/permissions";

const HPSIzletiPage = () => {
  return (
    <DataCentricPage
      needPermission={[Permissions.HPSKomisijaView, Permissions.Administration]}

      primaryModel={modelIzlet}
      primaryTitleToken="titles.izleti_hps"
      primaryView="komisija"
      primaryAllowAdd={false}
      primaryAllowView
      primaryDialogForm="komisija"
      primaryDialogComponent={HPSIzletForm}
      primaryAllowEdit={false}
      primaryAllowGeneratePDF
      primaryAllowShareIzlet={false}
      primaryAllowGenerateVodickiObrazac={false}
      primaryOverrideAPIUrl="hps/izleti?type=komisija"
      primaryExportLabel="buttons.export_xlsx_izleti"

      secondaryModel={modelIzletVodicSudionik}
      secondaryTitleToken="titles.vodici_sudionici"
      secondaryView="komisija"
      secondaryAllowView={false}
      
      baseRecordPath={modelIzlet.apiPath}
      childRecordRelativePath="vodici-i-sudionici"
      geomRelativePath="geom"
      miniMapBaseRecordQueryParams="?type=komisija"
      
      mapId={12}
      mapModel={modelIzlet}
    />
  )
};

export default HPSIzletiPage;
